import React, { Component } from 'react';
import { connect } from 'react-redux';
import { socketConnect } from 'socket.io-react';
import FacebookLogin from 'react-facebook-login';
import GoogleLogin from 'react-google-login';
import PropTypes from 'prop-types';
import { browserHistory, Link } from 'react-router';
import { userLogin } from 'store/user';
import Modal from 'components/Modal';
import InputValidation from 'components/InputValidation';
import { spin, stop } from 'store/spinner';
import LogoImage from 'assets/megafit-images/mf-logo.svg';
import bannerSignin from 'assets/megafit-images/sign-banner.png';
import LogoImageIcon from 'assets/megafit-images/mf-logo.svg';
import Masonry from 'react-masonry-component';
import DietPlanIcon from 'assets/megafit-images/diat-plan.gif';
import MasterIcon from 'assets/mastercard.svg';
import VisaIcon from 'assets/visa.svg';
class SignIn extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      email: '',
      password: '',
      smscode: '',
      showsms: false,
      errorModalMessage: '',
      showPassword: false,
      errors: {},
      xyz: false
    };
  }

  socketLogin = ({ type, data, message, banned, smscode }) => {

    if (this.SignInRef) {
      if (type === 'smsOk') {
        this.setState({
          showsms: true,
          errorModalMessage: message,
        });
      } else if (type === 'setOk') {
        const { location } = this.props;
        const { redirect } = location.query;
        this.props.login(data);
        if(redirect){
          browserHistory.push('/'+redirect);
        }else{
          browserHistory.push('/');
        }
      } else if (type === 'smsErr') {
        this.setState({
          errorModalMessage: message,
        });
      } else if (['setErr', 'facebookErr', 'googleErr'].indexOf(type) > -1) {
        const { errors } = data;
        const { email, password } = errors;
        if(email == undefined && password != undefined){
           message = password[0];
        }
        const bannedMessage = 'Dear Customer,\n' +
          'Thank you for your interest. We are really sorry but it seems that your profile cannot be activated. ' +
          'Please contact our team on team@megafit.ae or 02-444-2595 for further clarifications.\n' +
          'Regards,\n' +
          'MegaFitTeam';
        this.setState({ errorModalMessage: banned ? bannedMessage : message });
      }
    }
  };

  componentWillMount() {
    this.props.socket.on('login', this.socketLogin);
  }

  componentWillUnmount() {
    this.props.socket.removeListener('login', this.socketLogin);
  }

  componentDidMount() {
    setTimeout(() => this.setState({ xyz: true }), 10);
  }

  submit(e, browserId) {
    e.preventDefault();
    const { email, password, smscode } = this.state;
	console.log('Login Trigger');
    this.props.socket.emit('login', { type: 'set', data: { email, password, browserId, app: 'customer', smscode: smscode } });
  }

  submitFacebook(response, browserId) {
    if ('id' in response) {
      this.props.socket.emit('login', { type: 'facebook', data: { ...response, browserId }, app: 'customer' });
    }
  } 

  submitGoogle(response, browserId) {
    this.props.socket.emit('login', { type: 'google', data: { ...response, browserId }, app: 'customer' });
  }

  render() {
    const onChange = (name, value) => this.setState({ [name]: value });
    const { errors, errorModalMessage, email, password, xyz, showsms, smscode } = this.state;
    const { settings, browserId,stop, location } = this.props;
    const { redirect } = location.query;
    let redirectParam='';
    if(redirect!=undefined){
      redirectParam='?redirect='+redirect;
    }
    // const facebookAppId = settings.getValue('FACEBOOK_APP_ID');
    // const googleAppId = settings.getValue('GOOGLE_APP_ID'); Team@basiligo2024
    const facebookAppId = '';
    const googleAppId = '';
	//console.log(browserId);
    return (
      <div ref={el => (this.SignInRef = el)} className={`mf-container login-page`}>
      <div className='full-width'>
        <div className='sign-container'>
        <div className='sign-left'>
        <Link to='/checkout' ><img src={bannerSignin} alt='Megafit-Banner' /></Link>
            {/* <div className='sign-left-inner'>
              <div class="flex-container">
                  <div class="sign-content-left">
                      <h1> 
                          <span class="mainSpan"><span class="small-txt">Customize</span><span class="normal-txt"> Your Fuel,</span></span>
                          <span class="mainSpan"><span class="small-txt">Maximize</span><span class="normal-txt"> Your Gains</span></span>
                      </h1>
                  </div>
                  <div class="sign-content-right">
                      <p>Make you own Macro <br/>Counted Meals with</p>
                      <span class="yellow-box"><strong>MegaFit</strong> CustomFit<sup>®</sup></span>
                  </div>    
              </div>
            </div>             */}
        </div>
        <div className={`sign-right`}>
          <div class="sigin-holder">
            <div class="logo-holder">
              <div className='logo'>  <Link to='/' onClick={() => stop()} onlyActiveOnIndex><img src={LogoImage} alt='Megafit' /></Link></div>
              <div className='logo-icon'>  <Link to='/' onClick={() => stop()} onlyActiveOnIndex><img src={LogoImageIcon} alt='Megafit' /></Link></div>   
            </div>
            <div class="form-holder">
              <div class="marquee">
                <img src={DietPlanIcon} alt='megaFit' />
                <div class="diet-text">
                  <p>Plan your menu and choose your meals completely free before starting.</p><p>Sign in to start, select your macros and see the dish options.</p> 
                </div>        
              </div>    
              <div className='sign-up-form signinform'>
                <div className='sign-in-top mt-1'>
                <span className='colorTitle'>Sign In</span>
                <Link to='/sign-up' className='colorTitle ml-3'>Sign Up</Link>
                </div>
                <form className='form' onSubmit={e => this.submit(e, browserId)}>
                  <div className='sign-form-container'>
                  {!showsms && <div className='sign-up-input mt-5 email-field'><label class="textLeft">Email</label>
                    <InputValidation
                      value={email}
                      name='email'
                      onChange={onChange}
                      placeholder='Your Email'
                      errors={errors}
                      inputSelfClassName='standart-input b-rounded-blue'
                    />
                  </div>}
                  {!showsms && <div className='sign-up-input mt-4 pwd-field'><label class="textLeft">Password</label>
                    <InputValidation
                      type='password'
                      name='password'
                      value={password}
                      onChange={onChange}
                      placeholder='Your Password'
                      errors={errors}
                      inputSelfClassName='standart-input b-rounded-blue'
                    />
                  </div>}
                  {showsms && <div className='sign-up-input mt-4'>
                    <InputValidation
                      type='smscode'
                      name='smscode'
                      value={smscode}
                      onChange={onChange}
                      placeholder='Sms Code'
                      errors={errors}
                      inputSelfClassName='standart-input b-rounded-blue'
                    />
                  </div>}
                  <div className='search-title login-text mt-3'>
                  <p className='line-height-xsnormal login-text mb-0'>
                    By signing in or signing up, I agree to <strong>MegaFit</strong>&nbsp;
                    <Link to='/terms' >Terms & Conditions</Link>, <Link to='/refunds' >Refund & Cancellation policy</Link>, <Link to='/privacy-policy' >Privacy Policy</Link>,
                    I confirm that I am 18 years of age or older, and consent to receiving email communication.
                  </p>
                  </div>
                  <div className='login-text mt-3  text-right forgot-link'>
                    <span><Link to='/restore'>Forgot password?</Link></span>
                  </div></div>
                  <div className='sign-up-input mt-4 sign-up-button d-flex align-items-center justify-content-around'>
                    <input type='submit' value='Login' className='form-button letter-sm w-100' />
                  </div>
                </form>
                {/*<div className='search-title login-text mt-3'>
                  <span className='colorTitle letter-sm'>Or</span>
          </div>*/}
                {googleAppId && <GoogleLogin
                  clientId={googleAppId}
                  onSuccess={response => this.submitGoogle(response, browserId)}
                  buttonText='Sign in with Google'
                  className='sign-up-input mt-3 sign-up-button-google d-flex align-items-center justify-content-around'
                  onFailure={data => console.log(data)}
                />}
                {facebookAppId && <FacebookLogin
                  appId={facebookAppId}
                  size='small'
                  callback={response => this.submitFacebook(response, browserId)}
                  fields='name,email,picture,first_name,last_name'
                  textButton='Sign in with Facebook'
                  cssClass='sign-up-input mt-3 mb-2 sign-up-button-facebook d-flex align-items-center justify-content-around'
                />}
                <div className='mt-4 mr-1 text-center sign-up-bottom'>
              <span className='mt-1 mr-1 grey-text'>Don’t have an Account? </span>
                <span className='login-text'><Link to={`/sign-up${redirectParam}`}>Create your Account</Link></span>
               
                </div>
                {/* {redirectParam=='' && <div className='mt-4 mr-1 text-center sign-up-bottom'>
                <span className='build-menu'><Link to='/checkout' className="button-small transition paper-bc">Build your menu</Link></span></div>} */}
              </div>
              {errorModalMessage &&
                <Modal
                  close={() => this.setState({ errorModalMessage: '' })}
                  message={errorModalMessage}
                />
              }
            </div>
          </div>  
          <div className='footer_bottom_copyrights'>
              <ul className="inline-list payment-icons footer__section">
                <li className="icon--payment master"><img src={MasterIcon} alt='Mastercard' /></li>
                <li className="icon--payment master"><img src={VisaIcon} alt='Visa' /></li>
              </ul>
              <ul class="footer-block__details-content list-unstyled">
                  <li><p class="footer_links_head font-weight-semibold">Help &amp; Info:</p></li>
                  <li><a href="https://megafit.ae/pages/delivery-policy" class="link link--text list-menu__item list-menu__item--link" target='_blank'>
                    Delivery Policy
                  </a></li>
                  <li><a href="https://megafit.ae/pages/privacy-policy" class="link link--text list-menu__item list-menu__item--link" target='_blank'>
                    Privacy Policy
                  </a></li>
                  <li><a href="https://megafit.ae/pages/refund-cancellation-policy" class="link link--text list-menu__item list-menu__item--link" target='_blank'>
                    Refund &amp; Cancellation Policy
                  </a></li>
                  <li><a href="https://megafit.ae/pages/terms-and-conditions" class="link link--text list-menu__item list-menu__item--link" target='_blank'>
                    Terms &amp; Conditions
                  </a></li>
                </ul>
            </div>     
        </div>
      </div>
      </div>
      </div>
    );
  }
}

SignIn.propTypes = {
  socket: PropTypes.object.isRequired,
  settings: PropTypes.object,
  browserId: PropTypes.string,
  login: PropTypes.func.isRequired
};

const props = state => ({
  browserId: state.user.browserId,
  language: state.user.language,
  settings: state.settings
});

const actions = dispatch => ({
  login: user => dispatch(userLogin(user)),
  spin: () => dispatch(spin()),
  stop: () => dispatch(stop()),
});

export default socketConnect(connect(props, actions)(SignIn));
